module.exports = __webpack_public_path__ + "static/media/refrigerator.1894ed8a.svg";